import React from "react";
import BusDetailsCard from "./BusDetailsCard";

export default function Bus9() {
  return (
    <BusDetailsCard
      busId="bus9"
      title="Bus 9 - Route Details"
      busName="Bus 9"
      vehicleNo="TN74I9234"
      backTo="/?buses=1"
    />
  );
}